export function buildCategoryFormData({ nameEn, nameAr, descriptionEn, descriptionAr, image, majorIds }) {
    const formData = new FormData();
    formData.append('name_en', nameEn);
    formData.append('name_ar', nameAr);
    if (descriptionEn) formData.append('description_en', descriptionEn);
    if (descriptionAr) formData.append('description_ar', descriptionAr);
    if (image) formData.append('image', image);
    if (majorIds?.length) {
        majorIds.forEach((id) => formData.append('major_ids[]', id));
    }
    return formData;
}
